/**
 * Builds command-palette menus from loaded interface elements and current mode.
 */

import * as React from 'react';
import { useInterfaceElementsStore } from '@/stores/interfaceElementsStore';
import { useMode } from '@/contexts/ModeContext';
import type { MenuSearchResult } from '@/types/search.types';
import { buildDynamicSearchMenus } from '@/components/search/search-utils';

/**
 * Builds dynamic search menu entries from interface elements that are already loaded
 * in the store.
 */
export const useDynamicSearchMenus = (): MenuSearchResult[] => {
  const { mode } = useMode();
  const elementsByInterface = useInterfaceElementsStore((state) => state.elementsByInterface);
  const sidebarElements = elementsByInterface.sidebar ?? [];
  const adminsElements = elementsByInterface.admins ?? [];
  const tutorsElements = elementsByInterface.tutors ?? [];
  const volunteersElements = elementsByInterface.volunteers ?? [];
  const sessionsElements = elementsByInterface.sessions ?? [];
  const reportsElements = elementsByInterface.reports ?? [];

  return React.useMemo(
    () =>
      buildDynamicSearchMenus({
        mode,
        sidebarElements,
        adminsElements,
        tutorsElements,
        volunteersElements,
        sessionsElements,
        reportsElements,
      }),
    [
      mode,
      sidebarElements,
      adminsElements,
      tutorsElements,
      volunteersElements,
      sessionsElements,
      reportsElements,
    ],
  );
};
